import { ReactComponent as Accident } from "assets/images/icons/Accident.svg";
import { ReactComponent as BenefitsIcon } from "assets/images/icons/Benefits_icons.svg";
import { ReactComponent as HailFlood } from "assets/images/icons/Hail_Flood.svg";
import { ReactComponent as PersonalAccident } from "assets/images/icons/Personal_Accident.svg";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import * as utils from "../../helpers/utils";
import ProductCard from "./components/productCard";
import VehicleCard from "./components/vehicleCard";
import StyleWrapper from "./style";
import "./vehicle.css";

import Footer from "_shared/Footer/Footer";
import VehiclePreview from "_shared/VehicleInfoShared/VehiclePreview";
import MotorAccord from "application/motor/components/MotorAccord/MotorAccord";
import { ReactComponent as VehicleBlue } from "assets/images/icons/_Vehicle_blue.svg";
import isEmpty from "lodash/isEmpty";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getNationalList, getOccupationList, submitCRMCampaignApi } from "../../../../services/commonServices/index";
import { createQuotation, getDefaultValues, getProposal } from "../../services";
import OtherInformation from "./components/OtherInformation";
import PolicyDetail from "./components/PolicyDetails";
import Drivers from "./components/drivers";
import Features from "./components/features";

import Decleration from "_shared/Decleration/Decleration";
import OtherInfo from "_shared/OtherInfo/OtherInfo";
import PromoCode from "application/motor/components/PromoCode/PromoCode";
import brokenTraced from "assets/images/icons/broken_traced.svg";
import carDamage from "assets/images/icons/car_damage.svg";
import { useFormik } from "formik";
import { IdentificationList, ZoneList } from "helpers/utils";

import { Dialog } from "primereact/dialog";
import { Messages } from "primereact/messages";
import { Toast } from "primereact/toast";
import {
  setDeclarationsData,
  setOtherInfo,
  set_active_step,
  showErrorMessage,
  updateLoading,
} from "redux/actions/commonActions";
import {
  UpdateQuotation,
  setAppSelectedVehicle,
  setProposalDetails,
  updateCustomerDetails,
  updateVehiclesDetails
} from "redux/actions/motorActions";
import { sendEnquiry } from "services/medmal-service";
import * as globalUtils from "../../../../helpers/utils";
import { checkMissingData } from "../../helpers/utils";
import * as ApiWrapper from "../../services/serviceWrapper";
import SubCard from "./components/SubCard";
import useEncryptDecrypt from "../../../../helpers/use-decrypt";
const sanadCovers = [
  {
    text: "MotorEn.LiabilityThirdParties",
    icon: carDamage,
  },
];
const sanadPlus = [
  {
    text: "MotorEn.LiabilityThirdParties",
    icon: carDamage,
  },
  {
    text: "MotorEn.LossDamage",
    icon: brokenTraced,
  },
];
const alShamel = [
  {
    text: "MotorEn.LiabilityThirdParties",
    icon: carDamage,
  },
  {
    text: "MotorEn.LossDamage",
    icon: brokenTraced,
  },
  {
    text: "Motor.theft",
    icon: brokenTraced,
  },
  {
    text: "Motor.fire",
    icon: brokenTraced,
  },
  {
    text: "Motor.cntry_workshop_ntw",
    icon: brokenTraced,
  },
  {
    text: "Motor.hail_flood",
    icon: brokenTraced,
  },

];

const default_Nationality = {
  nationalityCode: "1",
  nationalityDescription: "SAUDI",
};

const PolicyDetails = (props) => {
  const {
    vehicles,
    customerDetails,
    personalFormDetails,
    isSme,
    drivers,
    driverObject,
    applicationDetailsStatus,
    changeDeductable,
    proposalPrice
  } = useSelector((state) => state.motor);
  customerDetails.idNumber = isSme ? personalFormDetails.crNumber : personalFormDetails.nationalId;

  const ref = useRef(null);
  const refInfo = useRef(null);
  const kycRef = useRef(null);
  const [submitAllForms, setSubmitAllForms] = useState(false);
  const [alshmalPlusupdate, setalshmalPlusupdate] = useState(false);
  const [filledValues, setFilledValues] = useState({});
  const [defaultValues, setDefaultValues] = useState();
  const [viewAllVehicles, setViewAllVehicles] = useState(false);
  const [proposalArray, setProposalArray] = useState([]);
  const [visibleSumary, setvisibleSumary] = useState(false);
  const [donotHavealshamal, setdonotHavealshamal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(vehicles[0]?.chassisNumber);
  const toast = useRef(null);
  const location = useLocation();
  const [selectedProposal, setSelectedProposal] = useState("");
  const [selectedMbiPlan, setSelectedMbiPlan] = useState("C");
  const [proposalToShow, setProposalToShow] = useState([]);
  const { t, i18n } = useTranslation();
  const [isNextButtonActive, setIsNextButtonActive] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const driversToShow = drivers;
  const currentStepIndex = useSelector((state) => state.common.stepper?.activeStep);
  const hasExposure = useSelector((state) => state.common.hasExposure);
  const motor = useSelector((state) => state.motor);
  const { isleadGeneratation } = useSelector((state) => state.motor);
  const { proposalDetails } = useSelector((state) => state.motor);


  const fullName =
    i18n.language === "ar"
      ? motor?.customerDetails?.araFullName == null ? motor?.customerDetails?.araFirstName + " " + motor?.customerDetails?.araMidName + " " + motor?.customerDetails?.araLastName : motor?.customerDetails?.araFullName
      : typeof motor?.customerDetails?.engFullName === 'undefined' || motor?.customerDetails?.engFullName === null ? motor?.customerDetails?.engFirstName + " " + motor?.customerDetails?.engMidName + " " + motor?.customerDetails?.engLastName : motor?.customerDetails?.engFullName
  const city = globalUtils.placeofbirthList.find(
    (obj) => obj.code === motor.customerDetails?.cityCode
  );
  const nationalityCode = motor?.customerDetails?.nationalityCode;
  const [defaultNationality, setDefaultNationality] = useState(default_Nationality);
  const [declaration, setDeclaration] = useState(true);
  const [declarationError, setDeclarationError] = useState(false);
  const [policyDateRepairType, setPolicyDateRepairType] = useState({
    agencyRepairRequired: "N",
    requiredInceptionDate: null,
    applyAll: true,
  });
  const [mcFormErrors, setMCFormErrors] = useState({});
  const [planChanged, setPlanChanged] = useState(false);
  const [forTagging, setForTagging] = useState(false);
  const [forTaggingVals, setForTaggingVals] = useState({ tagged: false, count: 0 });
  const [openPromoPopup, setOpenPromoPopup] = useState(false);
  const [promocode, setPromocode] = useState("");
  const [promoCodeApplied, setPromoCodeApplied] = useState(false);
  const [nationalListAPI, setNationalListAPI] = useState([]);
  const [occupationListAPI, setOccupationListAPI] = useState([]);
  const [showKycError, setShowKycError] = useState(false);
  const [motorDrive, setMotorDrive] = useState(true);
  const currentLanguageCode = i18n.language;
  const [oldLanguageCode, setOldLanguageCode] = useState(currentLanguageCode);
  const myRef = useRef(null);
  const [selectedPrice, setSelectedPrice] = useState();
  const [cityData, setCityData] = useState([]);
  const [ProposalNumber, setPraposalNumber]= useState("")
  const { businessLine } = useParams()
  const [openTab, setOpenTab] = useState(false)
   // REBRANDING COLORS
 let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
 if(businessLine === globalUtils.BUSINESS_LINE_PATHS.BSF) businessColor = globalUtils.BUSINESS_LINE_COLORS.BSF
 else if(businessLine === globalUtils.BUSINESS_LINE_PATHS.STC) businessColor = globalUtils.BUSINESS_LINE_COLORS.STC
 else if(businessLine === globalUtils.BUSINESS_LINE_PATHS.LUCID) businessColor = globalUtils.BUSINESS_LINE_COLORS.LUCID
 else if(businessLine === globalUtils.BUSINESS_LINE_PATHS.SNB) businessColor = globalUtils.BUSINESS_LINE_COLORS.SNB
 else if(businessLine === globalUtils.BUSINESS_LINE_PATHS.ALNAGHI) businessColor = globalUtils.BUSINESS_LINE_COLORS.ALNAGHI

 const encryptDecryptData = useEncryptDecrypt()
 const JWT = useSelector((state) => state.common.JWT);

 useEffect(() => {
  if (isEmpty(selectedProposal)) {
    
    if (proposalArray.length == "1" && vehicles.length == "1") {
      const found = proposalArray[0].proposals.proposalsArray.find(
        (element) => element?.productSubCode == "PRMotorImtiazeCO"
      );
      if (!isEmpty(found)) {
        
        setSelectedProposal(selectedProposal ? selectedProposal : "PRMotorImtiazeCO");
        setPraposalNumber(found?.proposalNumber); // Set proposal number here
      } else {
        
        setSelectedProposal(selectedProposal ? selectedProposal : "PRMotorImtiazeSP");
        const foundAlt = proposalArray[0].proposals.proposalsArray.find(
          (element) => element?.productSubCode == "PRMotorImtiazeSP"
        );
        
        setPraposalNumber(foundAlt?.proposalNumber); // Set proposal number here
      }
    } else if (proposalArray.length > 1) {
      let valueALshmall = false;
      proposalArray.forEach((itemelement) => {
        const HaveValue = itemelement.proposals.proposalsArray.find(
          (element) => element?.productSubCode == "PRMotorImtiazeCO"
        );
        if (isEmpty(HaveValue)) {
          setdonotHavealshamal(true);
          return (valueALshmall = true);
        }
        
      });
      if (valueALshmall.toString() == "true") {
        
        setSelectedProposal("PRMotorImtiazeSP");
        const foundSP = proposalArray.flatMap(item => item.proposals.proposalsArray).find(
          (element) => element?.productSubCode == "PRMotorImtiazeSP"
        );
        
        setPraposalNumber(foundSP?.proposalNumber); // Set proposal number here
      } else {
        
        setSelectedProposal("PRMotorImtiazeCOPlus");
        const foundCOPlus = proposalArray.flatMap(item => item.proposals.proposalsArray).find(
          (element) => element?.productSubCode == "PRMotorImtiazeCOPlus"
        );
        
        setPraposalNumber(foundCOPlus?.proposalNumber); // Set proposal number here
      }
    }
  }
}, [proposalArray, donotHavealshamal]);
  const footerContent = (
    <div>
      {/* <Button
        label="Add More Vehicle"
        icon="pi pi-car"
        onClick={() => addMoreVehicle()}
        className="p-button-text"
      /> */}
      <Button
        label={t("MotorEn.Policy-Selected-4")}
        icon="pi pi-times"
        onClick={() => setvisibleSumary(false)}
        className="p-button-text"
      />
      <Button
        label={t("MotorEn.Policy-Selected-5")}
        icon="pi pi-check"
        onClick={() => TriggerNavigate()}
        autoFocus
      />
    </div>
  );

  const addMoreVehicle = () => {
    navigate("/vehicle-details");
  };

  const TriggerNavigate = () => {
    setvisibleSumary(false);
    navigate(Boolean(businessLine) ? `/${businessLine}/motor/payment` : "/payment", { state: { lead: location.state?.lead, tmx: location.state?.tmx } });
  };

  const handleKeyPress = (e) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "+"];

    // Allow backspace, plus sign (+), and numbers
    if (!allowedKeys.includes(e.key) && (isNaN(Number(e.key)) || e.key === " ")) {
      e.preventDefault();
    }

    // Limit input to 13 characters
    if (e.target.value.length >= 13 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };



  useEffect(() => {
    const nationalListData = {
      nationalityCode: "",
      source: "TRVL",
      languageCode: currentLanguageCode?.slice(0, 1)?.toUpperCase(),
      channelCode: "85",
    };


    getNationalList(nationalListData).then((res) => {
      setNationalListAPI(res.NationalityDescription);
    });

    getOccupationList(nationalListData).then((res) => {
      setOccupationListAPI(res.OccupationDescription);
    });

    dispatch(set_active_step(2));

    window.lmSMTObj.page(location.pathname, {
      path: location.pathname,
      language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
      referrer: document.referrer,
      title: document.title,
      url: document.URL,
      search: "",
    });
  }, []);

  const [accordian, setaccordian] = useState(false);
  useEffect(() => {
    if (
      proposalArray &&
      proposalArray[0]?.proposals?.proposalsArray &&
      proposalArray[0]?.proposals?.proposalsArray.length > 0
      && location.state?.lead
    ) {
     
    }
  }, []);

  useEffect(() => {
    if (nationalListAPI.length > 0) {
      let defaultNationalitya = nationalListAPI.find(
        (obj) => obj.nationalityCode === nationalityCode
      );
      let finalNation = defaultNationalitya ? default_Nationality : defaultNationalitya;
      setDefaultNationality(
        defaultNationalitya ? default_Nationality : defaultNationalitya
      );
      formik.values.Nationality = finalNation;
    }
  }, [nationalListAPI]);

  const MC_formik = useFormik({
    initialValues: {
      priorPolicyCompanyName: null,
      priorPolicyExpiryDate: null,
      priorPolicyNumber: null,
      currentMileage: null,
      havePolicy: "true",
    },
    validate: (data) => {
      let errors = {};
      if (!data.priorPolicyExpiryDate) {
        errors.priorPolicyExpiryDate = "Required";
      }
      if (!data.priorPolicyNumber) {
        errors.priorPolicyNumber = "Required";
      }
      if (!data.currentMileage) {
        errors.currentMileage = "Required";
      }
      return errors;
    },
    onSubmit: (data) => { },
  });

  const formik = useFormik({
    initialValues: {
      nationalId: motor?.personalFormDetails?.nationalId,
      identificationType:
        motor?.personalFormDetails?.nationalId[0] === "1"
          ? IdentificationList[0]
          : motor?.personalFormDetails?.nationalId[0] === "2"
            ? IdentificationList[3]
            : motor?.personalFormDetails?.nationalId[0] === "3"
              ? IdentificationList[2]
              : IdentificationList[1],
      placeofIssue: city,
      expDate: new Date(customerDetails?.iqamaExpiryDate),
      FullName: fullName,
      dateofBirth: new Date(motor?.customerDetails?.gregDob?.split("-")?.reverse()?.join("-")),
      placeofbirth: "",
      Nationality: defaultNationality,
      MaritalStatus: {
        maritalStatus: "UnMarried",
        maritalStatusCode: "U",
      },
      MobileNo: globalUtils.prepareMobileNumber((personalFormDetails?.mobile || motor?.customerDetails?.mobile), true)?.slice(3, 12),
      Email: motor?.customerDetails?.email || "",
      sourceofIncome: { code: "Other", description: "Other" },
      City: customerDetails?.cityCode || "38",
      Zone: customerDetails?.regionCode || "1",
      Disctrict: customerDetails?.homeWaselEngDistrictName || "Riyadh",
      Street:
        motor?.customerDetails?.officeWaselEngStreetName ||
        motor?.customerDetails?.homeWaselEngStreetName ||
        "Riyadh",
      buildingNo:
        motor?.customerDetails?.homeWaselBuildingNumber ||
        motor?.customerDetails?.officeWaselBuildingNumber ||
        "0000",
      UnitNo: motor?.customerDetails?.officeSelfUnitNumber || "0000",
      ZipCode: customerDetails?.zipCode || customerDetails?.officeWaselPostalCode || "0000",
      Additionalnumber: motor?.customerDetails?.officeWaselAdditionalNumber || "0000",
      Attoney: "No",
      Policyowner: "Yes",
      PoliticallyExposed: "No",
      RoyalMember: "No",
      RelatedParty: "No",
      Occupationyes: "",
      Rankyes: "",
      Occupation: {
        occupationDescription: customerDetails?.occupationName || "Other",
        occupationCode: customerDetails?.occupationCode || "2",
      },
      Rank: "",
      Relevant: "",
      Employer: "",
      politicalValue: "No",
      AuthAuthroney: "",
      authnumber: "",
      atidcardNo: "",
      atdateofExpiry: "",
      atdateofBIRTH: "",
      atplaceofbirth: "",
      atrelationship: "",
      atauthrization: "",
      atCity: "",
      atDistract: "",
      atAdditionalnumber: "",
      atZipCode: "",
      atUnitNo: "",
      atbuildingNo: "",
      atStreet: "",
      attDisctrict: "",
      atnatZone: "",
      atNatCity: "",
      PolicyOName: "",
      PolciyidCard: "",
      PolcyNationality: "",
      atPolicyrelationship: "",
      Payjust: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.nationalId) {
        errors.nationalId = t("kyc.nat-req");
      }

      if (!data.placeofIssue) {
        errors.placeofIssue = t("kyc.placeOfIssue");
      }

      if (!data.expDate) {
        errors.expDate = t("kyc.expDate");
      }

      if (!data.dateofBirth) {
        errors.dateofBirth = t("kyc.dob");
      }

      if (!data.Nationality) {
        errors.Nationality = t("kyc.nationality");
      }

      if (!data.MaritalStatus) {
        errors.MaritalStatus = t("kyc.maritalStatus");
      }

      if (!data.MobileNo) {
        errors.MobileNo = t("kyc.mobileNo");

      }

      else if (!globalUtils.isValidSaudiPhoneNumber(globalUtils.prepareMobileNumber(data.MobileNo, true).slice(3, 12))) {
        errors.MobileNo = t("motor_person.mob_not_require");
      }

      if (!data.Email) {
        errors.Email = t("kyc.email");
      } else if (!globalUtils.isValidEmail(data.Email)) {
        errors.Email = t("kyc.email-id");
      }

      if (!data.sourceofIncome) {
        errors.sourceofIncome = t("kyc.sourceOfIncome");
      }

      if (!data.City) {
        errors.City = t("kyc.city");
      }

      if (!data.Zone) {
        errors.Zone = t("kyc.zone");
      }

      if (!data.Disctrict) {
        errors.Disctrict = t("kyc.district");
      }
      if (!data.Street) {
        errors.Street = t("kyc.street");
      }
      if (!data.buildingNo) {
        errors.buildingNo = t("kyc.buildingNo");
      }
      if (!data.UnitNo) {
        errors.UnitNo = t("kyc.unitNo");
      }
      if (!data.ZipCode) {
        errors.ZipCode = t("kyc.zipCode");
      }
      if (!data.Additionalnumber) {
        errors.Additionalnumber = t("kyc.additionalNumber");
      }
      if (data.Attoney === "Yes") {
        if (!data.AuthAuthroney) {
          errors.AuthAuthroney = t("MedMal.NameAuthorized");
        }
        if (!data.authnumber) {
          errors.authnumber = t("MedMal.AttorneyNumber");
        }
        if (!data.atidcardNo) {
          errors.atidcardNo = t("MedMal.AttorneyID");
        }
        if (!data.atdateofExpiry) {
          errors.atdateofExpiry = t("MedMal.DateExpiry");
        }
        if (!data.atdateofBIRTH) {
          errors.atdateofBIRTH = t("MedMal.DateBirth");
        }
        if (!data.atplaceofbirth) {
          errors.atplaceofbirth = t("MedMal.PlaceBirth");
        }
        if (!data.atrelationship) {
          errors.atrelationship = t("MedMal.Relationship");
        }
        if (!data.atauthrization) {
          errors.atauthrization = t("MedMal.TypeAuthorization");
        }
        if (!data.atCity) {
          errors.atCity = t("MedMal.CityRequired");
        }
        if (!data.atDistract) {
          errors.atDistract = t("MedMal.DistrictRequired");
        }
        if (!data.atStreet) {
          errors.atStreet = t("MedMal.StreetRequired");
        }
        if (!data.atAdditionalnumber) {
          errors.atAdditionalnumber = t("MedMal.AdditionalNumber");
        }
        if (!data.atZipCode) {
          errors.atZipCode = t("MedMal.ZipCode");
        }
        if (!data.atUnitNo) {
          errors.atUnitNo = t("MedMal.UnitNumber");
        }
        if (!data.atbuildingNo) {
          errors.atbuildingNo = t("MedMal.BuildingNumber");
        }
        if (!data.attDisctrict) {
          errors.attDisctrict = t("MedMal.NationalDistrict");
        }
        if (!data.atnatZone) {
          errors.atnatZone = t("MedMal.NationalZone");
        }
        if (!data.atNatCity) {
          errors.atNatCity = t("MedMal.NationalCity");
        }
      }

      if (data.Policyowner === "No") {
        if (!data.PolicyOName) {
          errors.PolicyOName = t("MedMal.NameRequired");
        }
        if (!data.PolciyidCard) {
          errors.PolciyidCard = t("MedMal.IDCard");
        }
        if (!data.PolcyNationality) {
          errors.PolcyNationality = t("MedMal.Nationality");
        }
        if (!data.atPolicyrelationship) {
          errors.atPolicyrelationship = t("MedMal.RelationshipRequired");
        }
        if (!data.Payjust) {
          errors.Payjust = t("MedMal.PaymentJustification");
        }
      }

      if (Object.keys(errors).length) {
        setShowKycError(true);
        scrollTo(kycRef)
        setOpenTab(true)
      } else {
        setShowKycError(false);
        // setOpenTab(false)
      }

      return errors;
    },

    onSubmit: (data) => {

      if (typeof filledValues.requiredInceptionDate === 'undefined') {
        scrollTo(refInfo)
        return
      }
      if (selectedProposal === "Mecha_MI") {
        const errors = {};
        if (!MC_formik.values.currentMileage) errors["currentMileage"] = "Required";
        if (MC_formik.values.currentMileage && MC_formik.values.currentMileage > 200000)
          errors["currentMileage"] = "Mileage should be less than 200000";
        if (Boolean(Object.keys(errors).length)) {
          setMCFormErrors(errors);
          return;
        }
      }
      dispatch(setDeclarationsData(decData));
      dispatch(setOtherInfo(data));
      if (declaration) {
        if (hasExposure) {
          let reqData = {
            subject: "Complete registration",
            mailType: "PLAINTEXT",
            app: "Mobile",
            module: "Motor",
            cc: "",
            bcc: "",
            body: JSON.stringify(formik.values),
            refCode: "",
            refValue: "",
            lang: "E",
            consumerRefNum: "",
            from: "no-reply@tawuniya.com.sa",
            to: "no-reply@tawuniya.com.sa",
          };
          sendEnquiry(reqData).then((response) => {
            if (response?.status === "1") {
              toast.current.show({
                severity: "success",
                summary: "Success",
                detail: "Email sent successfully",
                life: 7000,
              });
            }
          });
          navigate(businessLine ? `/${businessLine}/motor/kit/type=pep` : "/kit/type=pep");
        } else {
          setSubmitAllForms(true);
          const isAllValid = vehicles.filter((vehicle) => checkMissingData(vehicle)).length;
          if (
            !vehicles.length &&
            !isAllValid &&
            !applicationDetailsStatus &&
            !filledValues.requiredInceptionDate
          ) {
            dispatch(showErrorMessage(t("ERROR_FILL_ALL_REQUIRED")));
            return;
          } else {
            // diapatch to update customer mobile

            if (selectedProposal?.length > 0) {
              dispatch(
                updateCustomerDetails({
                  personalDetails: {
                    ...personalFormDetails,
                    email: formik.values.Email,
                  },
                  customerDetails: {
                    ...customerDetails,
                    mobile: globalUtils.prepareMobileNumber(!isEmpty(personalFormDetails.mobile) ? personalFormDetails.prefixMobile + personalFormDetails.mobile : data.MobileNo),
                    email: formik.values.Email,
                  },
                })
              );
              dispatch(updateLoading(true));

              createQuotation({
                productCode:
                  selectedProposal == "PRMotorImtiazeCOPlus"
                    ? "PRMotorImtiazeCO"
                    : selectedProposal,
                requiredInceptionDate: filledValues.requiredInceptionDate,
                mbiPlan: selectedMbiPlan,
                mbiData: MC_formik.values,
                promocode,
                ProposalNumber
              }, businessLine).then((res) => {

                if (res.data["resultCode"] == "S") {
                  if (isleadGeneratation === false) {
                    let tag = {
                      event: "generate_quote",
                      ecommerce: {
                        funnel_step: "step_8",
                        step_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value + "enerate_quote",
                        items: [
                          {
                            item_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                            item_category: "Motor Insurance",
                            item_class: "Individual",
                            is_car_owner: "Yes",
                            driver_yob: drivers?.[0]?.gregDob?.slice(-4),
                            vehicle_count: vehicles?.length,
                            vehicles:
                              vehicles.length > 1
                                ? "Multi Vehicles"
                                : proposalArray.map((proposal) => {
                                  const vehicle = vehicles.find((veh) => veh.chassisNumber === proposal.vehicle);
                                  return {
                                    vehicle_year: parseFloat(vehicle.yearOfManufacture),
                                    vehicle_brand: vehicle.makeName,
                                    vehicle_model: vehicle.modelName,
                                  };
                                }),
                          }
                        ]
                      }
                    }

                    console.log("tag", tag)
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push(tag);
                  } else {
                    let tag = {
                      event: "add_to_cart",
                      ecommerce: {
                        funnel_step: "step_3",
                        step_name: "elm_lead_generation_add_to_cart",
                        items: [
                          {
                            item_name: "ELM Lead Generation",
                            item_category: "Motor Insurance",
                            item_class: "Individual",
                            is_car_owner: "Yes",
                            TMX: location.state.tmx,
                            driver_yob: drivers?.[0]?.gregDob?.slice(-4),
                            vehicle_count: vehicles?.length,
                            vehicle_year:
                              vehicles?.length > 1 ? "MultipleVehicles" : vehicles?.[0]?.yearOfManufacture,
                            vehicle_brand:
                              vehicles?.length > 1 ? "MultipleVehicles" : vehicles?.[0]?.makeName,
                            vehicle_model:
                              vehicles?.length > 1 ? "MultipleVehicles" : vehicles?.[0]?.modelName,
                            items: proposalDetails?.map((proposal) => {
                              proposal?.proposals?.proposalsArray?.map((item) => {
                                if (item?.productSubCode !== selectedProposal) {
                                  const addons = [];
                                  item?.vehicleArray?.[0]?.applicableFeatureGroup?.forEach((feat) => {
                                    feat?.featureItems?.featureItemsArray?.forEach((featItem) => {
                                      addons.push({
                                        name: featItem?.featurename,
                                        id: featItem?.featurecode,
                                        price: featItem?.priceDetails?.priceDetailsArray[0]?.priceValue,
                                      });
                                    });
                                  });
                                  return {
                                    name: getTitle(item?.productSubCode)?.title_en,
                                    id: item?.productSubCode,
                                    price: item?.premium,
                                    addons,
                                  };
                                }
                              });
                            }),
                          }
                        ]
                      }
                    }

                    console.log("tag", tag)
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(tag);
                  }
                  dispatch(UpdateQuotation(res.data));
                  dispatch(set_active_step(currentStepIndex + 1));

                 if(res.data?.quotationNumber)
                  submitCRMCampaignApi(res.data.quotationNumber, 
                      selectedProposal === "PRMotorImtiazeCOPlus" ? businessLine + "PRMotorImtiazeCO" 
                      : businessLine + selectedProposal);

                      const quotationDetails = res.data;
                      const dataObject = {
                        idNumber: quotationDetails?.idNumber,
                        quoteNumber: quotationDetails?.quotationNumber,
                        product: "Motor",
                        language: i18n.language === "A" ? "AR" : "EN",
                        authToken: JWT,
                        gdpNumber: "",
                        policyNumber: "",
                        quotationDocumentLink: "",
                        isInternal: true,
                        subProduct: `${businessLine ? businessLine + ' Motor' : 'Motor'}`,
                      };
                      const redirectPaymentBaseURL = `${window.location.protocol}//${window.location.host}/one-page-payment/payment?`;
                      const encryptedData = encryptDecryptData({
                        data: dataObject,
                        secretPass: process.env.REACT_APP_FOREIGN_KEY_MOTOR,
                        encrypt: true,
                        isObjectData: true,
                      });
                      console.log(`${redirectPaymentBaseURL}id=${encryptedData}`);
                      debugger;
                      window.location.replace(`${redirectPaymentBaseURL}id=${encryptedData}`);

                  // navigate(
                  //   Boolean(businessLine) ? `/${businessLine}/motor/payment` : "/payment",
                  //   {
                  //     state: { lead: location.state?.lead, tmx: location.state?.tmx },
                  //   }
                  // );

                  //   if(vehicles.length != "1"){
                  //   setvisibleSumary(true);
                  // }else{
                  //   navigate("/payment",{ state: { lead: location.state?.lead,tmx:location.state?.tmx } });
                  // }

                  // navigate("/payment",{ state: { lead: location.state?.lead,tmx:location.state?.tmx } });
                } else {
                  toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: res.data.resultMessage,
                    life: 6000,
                  });
                  if (res.data.errorList[0].errorDescription == "CO vehicle age") {
                  }

                  // dispatch(showErrorMessage(t(res.data["resultMessage"])));
                }
              })
                .catch((error) => {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                  event: "error_displayed",
                  error_location: "Motor Insurance ELM Lead Generation",
                  funnel_step: "step_8",
                  error_messages: error
        });
                })
                .finally((e) => {
                  dispatch(updateLoading(false));
                });
            } else {
              toast.current.show({
                severity: "error",

                detail: t("MotorEn.motor-qaute"),
                life: 6000,
              });
            }
          }
        }
      } else {
        setDeclarationError(true);
      }
      window.lmSMTObj.track('policyCoverageNextClicked', {
        "productName": "Motor",
        "subProductName": "Motor",
        "policyCoverageType": getTitle(selectedProposal).title_en,
        "total": selectedPrice ? selectedPrice : getDefaultPrice(),
        "applyPromoCode": promoCodeApplied,
        "userName": customerDetails.engFirstName + " " + customerDetails.engLastName,
        "policyEffectiveDate": policyDateRepairType?.requiredInceptionDate,
        "vehicles": getVehiclesInfo(),
        "identificationType": formik.values.identificationType.descriptionEn,
        "placeOfIssue": formik.values.placeofIssue.descriptionEn,
        "idExpiryDate": new Date(formik.values.expDate),
        })
    },
  });


  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const showRTL = currentLanguageCode === "ar";

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };
  const getDefaultPrice = () => {
    return totalPriceCalcutawuniyar("PRMotorImtiazeCO").totalPrice +
      totalFeaturesPriceCalcutawuniyar("PRMotorImtiazeCO").featuresPrice +
      totalFeaturesPriceCalcutawuniyar("PRMotorImtiazeCO").featuresVAT

  }

  const getVehiclesInfo = () => {
    let objList = [];
    vehicles.map((vehicle, index) => {
      let obj = {}
      obj["vehicleModel"] = vehicle?.modelName
      obj["vehicleValue"] = vehicle?.vehicleValue
      objList.push(obj);
    })
    return objList;

  }

  const decData = {
    politicalExposure: {
      value: formik.values.PoliticallyExposed,
      details:
        formik.values.PoliticallyExposed === "Yes"
          ? {
            occupation: formik.values.Occupation,
            rank: formik.values.Rank,
          }
          : formik.values.PoliticallyExposed === "Yes-Part"
            ? {
              relevantName: formik.values.Relevant,
              employer: formik.values.Employer,
              occupation: formik.values.Occupation,
              rank: formik.values.Rank,
            }
            : {},
    },
    memberOfRoyalFamily: formik.values.RoyalMember,
    relatedParty: formik.values.RelatedParty,
  };

  useEffect(() => {
    if (showKycError.toString() == "true") {
      setaccordian(true);

      toast.current.show({
        severity: "error",
        detail: t("ERROR.KYC_ERROR"),
        life: 7000,
      });
    }
  }, [showKycError]);

  const scrollTo = (ref) => {
    if (ref && ref.current /* + other conditions */) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const loadGetProposal = (pCode = "", removePromo = false) => {
    dispatch(updateLoading(true));
    let tempArray = [];
    const tempVehicles = JSON.parse(JSON.stringify(vehicles));
    getProposal({ vehicles, customerDetails, promocode: pCode }, "ALL", businessLine)
      .then((response) => {
        if (response.resultCode && response.resultCode !== 'S') {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: response.resultMessage,
            life: 10000,
          });
          return;
        }
        response.forEach((item, i) => {
          tempArray.push(item.value.data);
        });
        const proToShow = tempArray?.find((item) => item.vehicle === selectedVehicle);
        proToShow?.proposals?.proposalsArray?.forEach((item) => {
          item.productSubCode === "Mecha_MI" && (item.priceDetails = item.mbiPlans[2].priceDetails);
        });

        const filteredArray = proToShow?.proposals?.proposalsArray;
 
        console.log(filteredArray, "filteredArray");

        if (filteredArray.length == "4") {

          if (
            selectedProposal == "PRMotorImtiazeCO" ||
            selectedProposal == "PRMotorImtiazeSP" ||
            selectedProposal == "Mecha_MI" ||
            selectedProposal == "MotorImtiazeTP"
          ) {
            const updatedAlsmalPrapsal = parseFloat(filteredArray[3].premium) + 565;
            filteredArray[3].premium = updatedAlsmalPrapsal.toString();
            setalshmalPlusupdate(true);
          }
        } else if (filteredArray.length == "5") {
          if (
            selectedProposal == "PRMotorImtiazeCO" ||
            selectedProposal == "PRMotorImtiazeSP" ||
            selectedProposal == "Mecha_MI" ||
            selectedProposal == "MotorImtiazeTP"
          ) {
            const updatedAlsmalPrapsal = parseFloat(filteredArray[4].premium) + 565;
            filteredArray[4].premium = updatedAlsmalPrapsal.toString();
            setalshmalPlusupdate(true);
          }
        }

        let product = filteredArray.filter(x => x.productSubCode !== "Mecha_MI")

        setProposalToShow(product);
        setProposalArray([...tempArray]);
        dispatch(setProposalDetails([...tempArray]));
        if (Boolean(pCode.length)) {
          setPromoCodeApplied(true);
          setTimeout(() => {
            setOpenPromoPopup(false);
          }, 4000);
        }
        if (removePromo) {
          setPromoCodeApplied(false);
          setPromocode("");
        }
      }).catch(error => {

      })
      .finally((e) => dispatch(updateLoading(false)));
  };

  useEffect(() => {
    loadGetProposal();
  }, [changeDeductable, vehicles]);

  useEffect(() => {
    if (proposalToShow.length > 2 || oldLanguageCode !== currentLanguageCode) {
      setOldLanguageCode(currentLanguageCode);
      loadGetProposal();
    }
  }, [selectedProposal, currentLanguageCode]);

  useEffect(() => {
    const CAR = vehicles?.find((item) => item.chassisNumber === selectedVehicle);
    const request = {
      productCode:
        selectedProposal == "PRMotorImtiazeCOPlus" ? "PRMotorImtiazeCO" : selectedProposal,
      yearOfManufacture: CAR?.yearOfManufacture,
      modelCode: CAR?.modelCode,
      makeCode: CAR?.makeCode,
      languageCode: i18n.language.slice(0, 1).toUpperCase(),
    };
    getDefaultValues(request, businessLine)
      .then((res) => {
        setDefaultValues(res.data);
      })
      .finally();
  }, [selectedProposal, selectedVehicle]);

  useEffect(() => {
    // for google tagging - after loading proposals
    if (Boolean(proposalArray.length) && Boolean(drivers.length) && Boolean(vehicles.length)) {
      if (!forTagging) {
        setForTaggingVals({ ...forTaggingVals, count: forTaggingVals.count + 1 });
        setForTagging(true);
      }
    }
  }, [proposalArray, drivers, vehicles]);

  useEffect(() => {
    // for google tagging - after loading proposals

    if (isleadGeneratation === true) {

      setForTaggingVals({ ...forTaggingVals, tagged: true });
      let valueProposal = proposalArray[0]?.proposals?.proposalsArray;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "carinfo_retrieved",
        ecommerce: {
          funnel_step: "step_2",
          step_name: "elm_lead_generation_carinfo_retrieved",
          TMX: location.state?.tmx,
          items: [
            {
              item_name: "ELM Lead Generation",
              item_category: "Motor Insurance",
              item_class: "Individual",
              is_car_owner: "Yes",
              vehicle_year: vehicles.length > 1 ? "MultipleVehicles" : vehicles[0]?.yearOfManufacture,
              vehicle_brand: vehicles.length > 1 ? "MultipleVehicles" : vehicles[0]?.makeName,
              vehicle_model: vehicles.length > 1 ? "MultipleVehicles" : vehicles[0]?.modelName,
              driver_yob: drivers[0]?.gregDob?.length>0 ? "2014": drivers[0].gregDob?.slice(-4),
              vehicles: proposalArray.map((proposal) => {
                const vehicle = vehicles.find((veh) => veh.chassisNumber === proposal.vehicle);
                return {
                  vehicle_year: parseFloat(vehicle.yearOfManufacture),
                  vehicle_brand: vehicle.makeName,
                  vehicle_model: vehicle.modelName,
                  items: proposal.proposals?.proposalsArray.map((item) => {
      
                  }),
                };
              }),
            }
          ]
        }
      });

    } else {


      setForTaggingVals({ ...forTaggingVals, tagged: true });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "get_price",
        ecommerce: {
          funnel_step: "step_7",
          step_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value + "get_price",
          items: [
            {
              item_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
              item_category: "Motor Insurance",
              item_class: "Individual",
              is_car_owner: "Yes",
              data_retrieval_method: vehicles[0].vehicleType === "registration" ? "Registration Card" : "Custom Card",
              // driver_yob: drivers[0].gregDob?.slice(-4),
              vehicle_count: vehicles.length,
              vehicles:
                vehicles.length > 1
                  ? "Multi Vehicles"
                  : proposalArray.map((proposal) => {
                    const vehicle = vehicles.find((veh) => veh.chassisNumber === proposal.vehicle);
                    return {
                      vehicle_year: parseFloat(vehicle.yearOfManufacture),
                      vehicle_brand: vehicle.makeName,
                      vehicle_model: vehicle.modelName,
                      items: proposal.proposals?.proposalsArray.map((item) => {

                        // HEMI TODO fix
                        // else if (item.productSubCode === "Mecha_MI") {
                        //   item.mbiPlans?.map((plan) => {
                        //     return {
                        //       name: plan.planName,
                        //       id: plan.planCode,
                        //       price: plan.premium,
                        //       addons: [],
                        //     };
                        //   });
                        // }
                      }),
                    };
                  }),
            }
          ]
        }
      });
    }
  }, []);

  useLayoutEffect(() => {
    const isAllValid = vehicles.filter((vehicle) => checkMissingData(vehicle)).length;
    setIsNextButtonActive(!!vehicles.length && !isAllValid);
  }, [vehicles]);

  const handleProposalChange = (proposal,proposalNumber, price) => {
    
    // console.log(proposal,"proppp")
    if (selectedProposal !== proposal) {
      setPraposalNumber(proposalNumber)
      setSelectedProposal(proposal);
      setMotorDrive(false);
      setPlanChanged(true);

      const vehiclesList = [...vehicles];
      vehiclesList.forEach((vehicle) => {
        // if (vehicle.chassisNumber === selectedVehicle) {
        if (vehicle.selectedFeatures) vehicle.selectedFeatures = [];
        // }
      });
      dispatch(updateVehiclesDetails([...vehiclesList]));
      setSelectedPrice(price);
    }
  };

  const changeVehicle = (vehicle) => {
    dispatch(setAppSelectedVehicle(vehicle));
    const proToShow = proposalArray?.find((item) => item.vehicle === vehicle);

    const filteredArray = proToShow?.proposals?.proposalsArray;

    const element = filteredArray.find((value) => {
      return value.productSubCode == "PRMotorImtiazeCOPlus";
    });

    // const resultfilteredArray = filteredArray.find(({ obj }) => obj.productSubCode === "PRMotorImtiazeCOPlus");
    if (!element) {
      filteredArray.map((item) => {
        if (item.productSubCode == "PRMotorImtiazeCO") {
          // filteredArray.push({ ...item, productSubCode: "PRMotorImtiazeCOPlus" });
        }
      });
    }
    ;
    if (filteredArray.length == "4") {
      // if(alshmalPlusupdate == false){
      if (
        selectedProposal == "PRMotorImtiazeCO" ||
        selectedProposal == "PRMotorImtiazeSP" ||
        selectedProposal == "Mecha_MI" ||
        selectedProposal == "MotorImtiazeTP"
      ) {
        const updatedAlsmalPrapsal = parseFloat(filteredArray[3].premium) + 565;
        filteredArray[3].premium = updatedAlsmalPrapsal.toString();
        setalshmalPlusupdate(true);
      }
    } else if (filteredArray.length == "5") {
      if (
        selectedProposal == "PRMotorImtiazeCO" ||
        selectedProposal == "PRMotorImtiazeSP" ||
        selectedProposal == "Mecha_MI" ||
        selectedProposal == "MotorImtiazeTP"
      ) {
        const updatedAlsmalPrapsal = parseFloat(filteredArray[4].premium) + 565;
        filteredArray[4].premium = updatedAlsmalPrapsal.toString();
        setalshmalPlusupdate(true);
      }
    }

    let product = filteredArray.filter(x => x.productSubCode !== "Mecha_MI")

    setProposalToShow(product);
    setSelectedVehicle(vehicle);
  };

  const getProductCovers = () => {
    return [
      {
        title: t("MotorEn.LiabilityThirdParties"),
        icon: <BenefitsIcon />,
        products: ["MotorImtiazeTP", "PRMotorImtiazeSP", "PRMotorImtiazeCO"],
      },
      {
        title: t("MotorEn.LossDamage"),
        icon: <Accident />,
        products: ["PRMotorImtiazeCO", "PRMotorImtiazeSP"],
      },
      {
        title: t("MotorEn.NaturalDisasters"),
        icon: <HailFlood />,
        products: ["PRMotorImtiazeCO", "PRMotorImtiazeSP"],
      },
      {
        title: t("Motor.EmergencyMedical"),
        icon: <PersonalAccident />,
        products: ["PRMotorImtiazeCO"],
      },
    ];
  };

  const getVehiclesList = () => {
    return viewAllVehicles ? vehicles : vehicles.slice(0, 4);
  };

  const getTitle = (code) => {
    switch (code) {
      case "MotorImtiazeTP":
        return {
          title: t("Motor.Sanad"),
          subTitle: t("Motor.Third_Party_Liability"),
          p: t("Motor.Third_Party_limit"),
          title_en: "Sanad",
        };
      case "PRMotorImtiazeSP":
        return {
          title: t("Motor.Sanad_Plus"),
          subTitle: t("Motor.owen_damage"),
          p: t("Motor.Sanad_limit"),
          title_en: "Sanad Plus",
        };
      case "PRMotorImtiazeCO":
        return {
          title: t("Motor.AlShamel"),
          subTitle: t("Motor.AlShamel_covers"),
          p: t("Motor.AlShamel_covers_2"),
          title_en: "Al Shamel",
        };

      default:
        return {
          title: t("Motor.Mechanical_Breakdown"),
          subTitle: t("Motor.Mechanical_Breakdown_Covers"),
          p: t("Motor.Mechanical_Breakdown_Covers_2"),
          title_en: "Mechanical Breakdown",
        };
    }
  };

  const savePolicyDetails = (data) => {
    //  // console.log(data);
    setPolicyDateRepairType(data);
    const values = { ...filledValues };
    setFilledValues({ ...values, ...data });
    if (data.applyAll) {
      const vehiclesList = [...vehicles];
      vehiclesList.forEach((vehicle) => {
        vehicle.agencyRepairRequired = data.agencyRepairRequired;
      });
      dispatch(updateVehiclesDetails([...vehiclesList]));
      data.agencyRepairRequired !== policyDateRepairType.agencyRepairRequired && loadGetProposal();
    }
    if (data.agencyRepairRequired) {
      const vehiclesList = [...vehicles];
      vehiclesList.forEach((vehicle) => {
        if (vehicle.chassisNumber === selectedVehicle) {
          vehicle.agencyRepairRequired = data.agencyRepairRequired;
        }
      });
      dispatch(updateVehiclesDetails([...vehiclesList]));
      data.agencyRepairRequired !== policyDateRepairType.agencyRepairRequired && loadGetProposal();
    }
  };


  const nextBtnHandler = () => { };

  const backBtnHandler = () => {
    dispatch(set_active_step(currentStepIndex - 1));
    navigate(businessLine ? `/${businessLine}/motor/vehicle-details` : "/vehicle-details");
  };

  useEffect(() => {
    totalFeaturesPriceCalcutawuniyar(selectedProposal);
    // handleProposalChange()
  }, [selectedProposal]);

  const totalFeaturesPriceCalcutawuniyar = (productSubCode) => {
    if (productSubCode !== selectedProposal) {
      return {
        featuresPrice: 0,
        featuresVAT: 0,
      };
    }
    let TotalPrice = 0;
    // console.log(vehicles,productSubCode,"carToPrice");

    vehicles.forEach((carToPrice) => {
      if (carToPrice.chassisNumber === selectedVehicle) {
        if (carToPrice?.selectedFeatures?.length) {
          carToPrice?.selectedFeatures?.forEach((element) => {
            element?.featureItems?.featureItemsArray?.forEach((item) => {
              item.priceDetails?.priceDetailsArray?.forEach((p) => {
                TotalPrice += +p.priceValue;
              });
            });
          });
        }
      }
    });

    const VATValue = +TotalPrice * 0.15;
    const featurePrice = {
      featuresPrice: Math.round(TotalPrice),
      featuresVAT: Math.round(VATValue),
    };
    return productSubCode === "Mecha_MI"
      ? {
        featuresPrice: 0,
        featuresVAT: 0,
      }
      : featurePrice;
  };

  const totalPriceCalcutawuniyar = (productSubCode) => {
    let TotalPrice = 0;
    let TotalBefore = 0;
    const selectedPep = proposalToShow?.find((item) => item.productSubCode === productSubCode);


    if (productSubCode === "Mecha_MI") {

    } else {
      TotalPrice = +selectedPep?.premium;
      TotalBefore = +selectedPep?.premiumBeforeDiscount;
      selectedPep?.isMin && selectedPep?.isMin !== isMin && setIsMin(selectedPep?.isMin)
    }
    const VATValue = +TotalPrice * 0.15;
    return {
      totalPrice: Math.round(TotalPrice),
      totalVAT: Math.round(VATValue),
      totalBefore: Math.round(TotalBefore),
    };
  };

  const getSingleVehiclePrice = (chassisNumber) => {
    let TotalPrice = 0;
    proposalArray.forEach((pep) => {
      if (pep.vehicle === chassisNumber) {
        const selectedPep = pep.proposals?.proposalsArray?.find(
          (item) => item.productSubCode === selectedProposal
        );
        selectedPep?.priceDetails?.priceDetailsArray?.forEach((element) => {
          if (element.priceCode === "TOTC") {
            TotalPrice += +element.priceValue;
            return;
          }
        });
      }
    });

    const VATValue = +TotalPrice * 0.15;

    return {
      totalPrice: TotalPrice,
      totalVAT: Math.round(VATValue),
    };
  };

  const handleApplyPromo = async () => {
    try {
      dispatch(updateLoading(true));

      const promoReq = {
        p_id_no: customerDetails.idNumber,
        p_promo_code: promocode,
        p_lob_code:
          selectedProposal == "PRMotorImtiazeCOPlus" ? "PRMotorImtiazeCO" : selectedProposal,
        p_endType: "PSL",
        lang_code: i18n.resolvedLanguage === "ar" ? "A" : "E",
      };
      const promoRes = await ApiWrapper.validatePromoCode(promoReq);
      if (promoRes && promoRes.resultCode === "S") {
        loadGetProposal(promocode);
      } else if (promoRes && promoRes.resultCode === "V") {
        dispatch(updateLoading(false));

        handleApplyPromoRetry(promocode, selectedProposal)
      } else {
        Promise.reject();
      }
    } catch (error) {
      dispatch(updateLoading(false));
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.msg ? error.msg : "Something went wrong. Try Again!",
        life: 6000,
      });
    }
  };


  const handleApplyPromoRetry = (promocode, selectedProposal) => {

    dispatch(updateLoading(true));

    const Lastpraposal = selectedProposal;

    const NewPaposalList = proposalToShow.filter(praposal => praposal.productSubCode != Lastpraposal)
    NewPaposalList.map((list, i) => {
      const promoReq = {
        p_id_no: customerDetails.idNumber,
        p_promo_code: promocode,
        p_lob_code:
          list.productSubCode == "PRMotorImtiazeCOPlus" ? "PRMotorImtiazeCO" : list.productSubCode,
        p_endType: "PSL",
        lang_code: i18n.resolvedLanguage === "ar" ? "A" : "E",
      };
      ApiWrapper.validatePromoCode(promoReq).then((response) => {
        if (response && response.resultCode === "S") {

          setSelectedProposal(list.productSubCode);
          loadGetProposal(promocode);
          return;
        } else if (response && response.resultCode === "V") {
          dispatch(updateLoading(false));

        } else {
          Promise.reject();
        }
      }).finally((e) => {
        dispatch(updateLoading(false));
      });



    })


  }
  useEffect(() => {
    const NewVal = proposalToShow;
    if (NewVal.length == "4") {
      if (selectedProposal == "PRMotorImtiazeCOPlus") {
        const updatedAlsmalPrapsal = parseFloat(NewVal[3].premium) - 564;
        NewVal[3].premium = updatedAlsmalPrapsal.toString();
      }
    } else if (NewVal.length == "5") {
      if (selectedProposal == "PRMotorImtiazeCOPlus") {
        const updatedAlsmalPrapsal = parseFloat(NewVal[4].premium) - 564;
        NewVal[4].premium = updatedAlsmalPrapsal.toString();
      }

    }
  }, [selectedProposal]);
  const handleRemovePromo = () => {
    loadGetProposal("", true);
  };

  useEffect(() => {
    isleadGeneratation && formik.submitForm();
    // msgs.current.clear();
  }, []);

  const msgs = useRef(null);
  const [isMin, setIsMin] = useState(false);

  useEffect(() => {
    msgs.current.clear();
    if (isMin === 'Y') {
      msgs?.current?.show([
        {
          sticky: true, severity: 'success', summary: '', detail:
            `${i18n.language === 'ar' ? "لقد حصلت على الحد الأدنى لسعر التأمين" : "You have reached minimum insurance price limit"}`
          , closable: true
        },
      ]);
    } else {
      msgs.current.clear();
    }
  }, [isMin]);

  useEffect(() => {
    setSelectedPrice(totalPriceCalcutawuniyar(selectedProposal).totalPrice)
  }, [selectedProposal, selectedPrice]);

  const [avctivateSpSub, setAvctivateSpSub] = useState('');
  const onAvctivateSpSub = (deductible) => {
    setAvctivateSpSub(deductible);
    vehicles.forEach(element => {
      element.deductibleSP = deductible;
    });
    loadGetProposal(); // Siraj Request
  }

  useEffect( ()=> {
    onAvctivateSpSub('1250')
  }, [])

  return (
    <StyleWrapper className={i18n.language === "ar" ? "ar" : ""} businessColor={businessColor}>
      <Toast ref={toast} />
      <div className="row p-0">
        <MotorAccord customerDetails={customerDetails} />
      </div>
      <Messages ref={msgs} />

      {vehicles.map((car, i) => (
        <div
          key={`carPolicy_${i}`}
          className={car.chassisNumber === selectedVehicle ? "" : "d-none"}
        >
          <div className="sections-container">
            <div className="promo_section ">
              <div>
                <div className="d-flex justify-content-between">
                  <h4 className="fm-bliss2-bold">{t("PolicyCoverage")}</h4>
                </div>
                <div className="d-flex justify-content-between">
                  <p>{t("MotorEn.SelectedPolicy")}</p>
                </div>
              </div>
              {businessLine !== "snb" && (
                <div className="promo_section_div" onClick={() => setOpenPromoPopup(true)}>
                  <h5 style={{ color: businessColor }}>{t("PAYMENT.APPLY_PROMOCODE")}</h5>
                </div>
              )}
            </div>
            <Divider />

            <div className="product_wrapper mt-5 mb-5" id="section-1">
              {proposalToShow?.map((item, i) => (
                <>
                  {isleadGeneratation && item.productSubCode !== "PRMotorImtiazeSP" && (
                    <ProductCard
                      businessColor={businessColor}
                      businessLine={businessLine}

                      key={`ProductCard_${i}`}
                      className="mx-1"
                      title={getTitle(item.productSubCode).title}
                      subTitle={getTitle(item.productSubCode).subTitle}
                      par={getTitle(item.productSubCode).p || ""}

                      price={
                        totalPriceCalcutawuniyar(item.productSubCode).totalPrice +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                      }
                      priceBefore={
                        totalPriceCalcutawuniyar(item.productSubCode).totalBefore +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice
                      }
                      vat={
                        totalPriceCalcutawuniyar(item.productSubCode).totalVAT +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                      }
                      onSelect={() =>
                        handleProposalChange(
                          item.productSubCode,
                          item.proposalNumber,
                          totalPriceCalcutawuniyar(item.productSubCode).totalPrice +
                            totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice +
                            totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                        )
                      }
                      isRecommended={item.productSubCode === "PRMotorImtiazeCO"}
                      isActive={selectedProposal === item.productSubCode}
                      showChip={
                        item.productSubCode == "PRMotorImtiazeCO" ||
                        item.productSubCode == "PRMotorImtiazeCOPlus"
                      }
                      // showActiveCtx={item.productSubCode !== "Mecha_MI"}
                      activeCtx={
                        item.productSubCode === "MotorImtiazeTP"
                          ? sanadCovers
                          : item.productSubCode === "PRMotorImtiazeSP"
                          ? sanadPlus
                          : item.productSubCode === "PRMotorImtiazeCO" || "PRMotorImtiazeCOPlus"
                          ? alShamel
                          : []
                      }
                    />
                  )}
                  {!isleadGeneratation && (
                    <ProductCard
                      businessColor={businessColor}
                      businessLine={businessLine}

                      key={`ProductCard_${i}`}
                      className="mx-1"
                      title={getTitle(item.productSubCode).title}
                      subTitle={getTitle(item.productSubCode).subTitle}
                      par={getTitle(item.productSubCode).p || ""}

                      price={
                        totalPriceCalcutawuniyar(item.productSubCode).totalPrice +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                      }
                      priceBefore={
                        totalPriceCalcutawuniyar(item.productSubCode).totalBefore +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice
                      }
                      vat={
                        totalPriceCalcutawuniyar(item.productSubCode).totalVAT +
                        totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                      }
                      onSelect={() =>
                        handleProposalChange(
                          item.productSubCode,
                          item.proposalNumber,
                          totalPriceCalcutawuniyar(item.productSubCode).totalPrice +
                            totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresPrice +
                            totalFeaturesPriceCalcutawuniyar(item.productSubCode).featuresVAT
                        )
                      }
                      isRecommended={item.productSubCode === "PRMotorImtiazeCO"}
                      isActive={selectedProposal === item.productSubCode}
                      showChip={
                        item.productSubCode == "PRMotorImtiazeCO" ||
                        item.productSubCode == "PRMotorImtiazeCOPlus"
                      }
                      // showActiveCtx={item.productSubCode !== "Mecha_MI"}
                      activeCtx={
                        item.productSubCode === "MotorImtiazeTP"
                          ? sanadCovers
                          : item.productSubCode === "PRMotorImtiazeSP"
                          ? sanadPlus
                          : item.productSubCode === "PRMotorImtiazeCO" || "PRMotorImtiazeCOPlus"
                          ? alShamel
                          : []
                      }
                    />
                  )}
                </>
              ))}
            </div>
            {selectedProposal === "PRMotorImtiazeSP" &&
              defaultValues?.spDeductibleList?.map((spItem, index) => {
                return (
                  <SubCard
                    totalPrice={spItem.deductible}
                    claimAmount={spItem.coverage}
                    activeCard={spItem.deductible === avctivateSpSub}
                    onCardActive={onAvctivateSpSub}
                  />
                );
              })}

            <Divider className="mt-.5 mb-5" />


            <div className="row mt-4 mb-4 next-box">
              <div className="col-md-6 col-xs-12 mt-2 policy-row">
                {" "}
                <div className="Dec-Input">
                  <span
                    className={"p-float-label p-input-icon-left w-100 " + (showRTL ? " ar" : "")}
                  >
                    {/* <i className="" dir="ltr" >+966</i> */}
                    <InputText
                      id="MobileNo"
                      name="MobileNo"
                      maxLength={9}
                      className={`font-bliss fm-tawuniyafm-tawuniya ${
                        currentLanguageCode === "ar" ? "mobile-no-direction-ar" : ""
                      }`}
                      value={formik.values.MobileNo}
                      onChange={formik.handleChange}
                      // disabled={props.mobileNumberDisable || disableInput}
                      placeholder="Ex : 5xxxxxxxx"
                      onKeyDown={handleKeyPress}
                    />
                    <label>{i18n.t("other_info.mob_no")}</label>
                  </span>
                  <div>{getFormErrorMessage("MobileNo")}</div>
                </div>
              </div>
              <div className="col-md-6 col-xs-12 mt-2">
                {" "}
                <div className="Dec-Input">
                  <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                    <InputText
                      name="Email"
                      id="Email"
                      value={formik.values.Email}
                      onChange={formik.handleChange}
                      // disabled={props.emailDisable || disableInput}
                      className="fm-tawuniya"
                    />
                    <label>{i18n.t("other_info.email")}</label>
                  </span>
                  <div>{getFormErrorMessage("Email")}</div>
                </div>
              </div>
            </div>
            <div className="row">
              <p className="text-md m-0">{t("MotorEn.PolicyDetails")}</p>
            </div>
            <Divider />
            <div ref={refInfo}>
              <PolicyDetail
                businessColor={businessColor}
                data={policyDateRepairType}
                sendValues={(e) => savePolicyDetails(e)}
                hideWorkshop={
                  selectedProposal == "PRMotorImtiazeCO" ||
                  selectedProposal == "PRMotorImtiazeCOPlus"
                    ? false
                    : true
                }
                selectedProposal={selectedProposal}
                motorDrive={motorDrive}
                setMotorDrive={setMotorDrive}
                businessLine={businessLine}
              />
            </div>

            <Divider />

            <div className="d-flex justify-content-between">
              <p className="text-md m-0 fm-bliss2-regular ">{t("MotorEn.VehicleList")}</p>
              {!isNextButtonActive && (
                <p className="text-danger m-0">
                  <i className="pi pi-info-circle mx-2" />
                  {t("Motor.PleaseUpdate")}
                </p>
              )}
            </div>
            <Divider />

            <div className="vehicles-list d-flex">
              {getVehiclesList().map((ele, i) => (
                <div onClick={() => changeVehicle(ele.chassisNumber)}>
                  <VehicleCard
                    businessColor={businessColor}
                    key={`VehicleCard_${i}`}
                    className={
                      "my-2 vehicle_card" + (ele.chassisNumber === selectedVehicle ? " active" : "")
                    }
                    // onClick={(e)=> updatePraposal(e)}
                    plateNumber={ele.plateNumber}
                    price={
                      getSingleVehiclePrice(ele.chassisNumber).totalPrice +
                      getSingleVehiclePrice(ele.chassisNumber).totalVAT
                    }
                    vehicle={ele}
                  />
                </div>
              ))}
            </div>
            {vehicles.length > 4 && (
              <div className="vehicles-list-control d-flex my-4 justify-content-center">
                {/* <Button className="prev" icon="pi pi-angle-left" label={t("policyDetails.prev")}/> */}
                <Button
                  className="view-all"
                  onClick={() => setViewAllVehicles(!viewAllVehicles)}
                  label={
                    viewAllVehicles
                      ? t("policyDetails.view-less-vehicles")
                      : t("policyDetails.view-all-vehicles")
                  }
                />
                {/* <Button className="next" icon="pi pi-angle-right" iconPos="right"  label={t("policyDetails.next")} /> */}
              </div>
            )}

            <div className="row">
              {/* <p className="fm-tawuniyatext-md m-0 mt-4">
                {t("STEPPER.VEHICLEDETAILS")}
              </p> */}
              {vehicles
                ?.filter((item) => item.chassisNumber === selectedVehicle)
                .map((vehicle, index) => {
                  if (vehicle.vehicleValue)
                    vehicle.vehicleValue = parseInt(vehicle.vehicleValue.toString()).toString();
                  return (
                    <VehiclePreview
                      allowEdit={true}
                      hideDelete={!vehicles.length > 1}
                      key={`VehiclePreviewCard_${index}`}
                      vehicle={vehicle}
                      serialNumber={vehicle.serialNumber}
                      hideDeduct={
                        selectedProposal === "PRMotorImtiazeCO"
                          ? false
                          : selectedProposal === "PRMotorImtiazeCOPlus"
                          ? false
                          : true
                      }
                      hideVehicleValue={selectedProposal === "PRMotorImtiazeCO" ? false : true}
                      // autoSubmit={true}
                      opened={false}
                      loadProposals={loadGetProposal}
                      setIsNextButtonActive={setIsNextButtonActive}
                    />
                  );
                })}
            </div>
            <Divider />

            <Drivers
              personalFormDetails={personalFormDetails}
              driverObject={driverObject}
              vehicle={selectedVehicle}
              drivers={driversToShow}
              loadGetProposal={loadGetProposal}
              hideDriverEdit="true"
              businessColor={businessColor}
            />
            <Divider />

            {selectedProposal !== "Mecha_MI" &&
              proposalToShow.length > 0 &&
              !isleadGeneratation && (
                <>
                  <div className="row" ref={ref}>
                    <p className="text-md fm-tawuniyamb-4">{t("MotorEn.ExtendPolicy")}</p>
                  </div>
                  <Features
                    vehicle={selectedVehicle}
                    selectedProposal={selectedProposal}
                    proposalToShow={proposalToShow}
                    setSelectedCar={setSelectedVehicle}
                    planChanged={planChanged}
                    setPlanChanged={setPlanChanged}
                    businessColor={businessColor}
                    businessLine={businessLine}
                  />
                  <Divider />
                </>
              )}

            <OtherInformation
              submitAllForms={submitAllForms}
              driversList={drivers}
              defaultValues={defaultValues}
              businessColor={businessColor}
            />
            <Divider />

            <div className="declaration mt-2">
              <div ref={kycRef}>
                <OtherInfo
                  businessColor={businessColor}
                  id="section-1"
                  accordian={accordian}
                  formik={formik}
                  errorShow={showKycError}
                  nationalIdDisable={true}
                  placeofIssueDisable={true}
                  fullNameDisable={fullName}
                  dobDisable={!!customerDetails?.gregDob}
                  mobileNumberDisable={false}
                  cityDisable={!!customerDetails?.cityCode}
                  buildingDisable={
                    !!customerDetails?.homeWaselBuildingNumber ||
                    !!customerDetails?.officeWaselBuildingNumber
                  }
                  additionalNumberDisable={!!customerDetails?.officeWaselAdditionalNumber}
                  identificationTypeDisable={true}
                  regionDisable={!!customerDetails?.regionCode}
                  streetDisable={
                    !!customerDetails?.officeWaselEngStreetName ||
                    !!customerDetails?.homeWaselEngStreetName
                  }
                  unitDisable={!!customerDetails?.officeSelfUnitNumber}
                  zipDisable={
                    !!customerDetails?.zipCode || !!customerDetails?.officeWaselPostalCode
                  }
                  activeIndex={1}
                  setCityData={setCityData}
                  openTab={openTab}
                  setOpenTab={setOpenTab}
                />
                <Divider />

                <Decleration formik={formik} businessColor={businessColor} />
              </div>
            </div>
            <div className="conditions-section mt-3">
              {declarationError && (
                <small className="p-error">{t("Motor.SelectDeclaration")}</small>
              )}
            </div>
          </div>

          <div className={`${utils.showMobile() ? "footer-right-mob" : "footer-right"}`}>
            <Footer
              totalPriceSar={i18n.t("RIGHTFOOTER.SAR")}
              showNextBtn={true}
              disableNextBtn={!proposalToShow.length || !isNextButtonActive}
              nextBtnHandler={formik.submitForm}
              nextBtnLabel={i18n.t("RIGHTFOOTER.NEXT")}
              showBackBtn={true}
              backBtnHandler={backBtnHandler}
              showTotalPrice={true}
              showSummary={true}
              totalPriceValue={proposalPrice !== undefined ? proposalPrice : getDefaultPrice() || 0}
            />
          </div>
        </div>
      ))}
      <PromoCode
        visible={openPromoPopup}
        setVisible={setOpenPromoPopup}
        promocode={promocode}
        setPromocode={setPromocode}
        showTotalPrice={true}
        showSummary={true}
        // motorSummary={priceSummary}

        handleApplyPromo={handleApplyPromo}
        promoCodeApplied={promoCodeApplied}
        handleRemovePromo={handleRemovePromo}
        businessColor={businessColor}
      />
      <Dialog
        visible={visibleSumary}
        onHide={() => setvisibleSumary(false)}
        footer={footerContent}
      >
        <p className="m-0">
          <div className="continer">
            <div className="row mx-3">
              <div className="col-md-12">
                <p className="">
                  {t("MotorEn.Policy-Selected")}:{" "}
                  <span className="Policy-title">{getTitle(selectedProposal)?.title}</span>
                </p>
              </div>
            </div>
            <div className="row mt-3 mx-3">
              <div className="col-md-12 mt-2 mb-4">
                <p className="">{t("MotorEn.Policy-Selected-1")}</p>
              </div>
              {getVehiclesList().map((ele, i) => (
                <div className="col-md-4">
                  <div className="vehicle_card_sum vehicle-Sum-class">
                    <div className="card_wrapper d-flex">
                      <div>
                        <VehicleBlue />
                      </div>
                      <div className="info_wrapper justify-content-center">
                        <p>{ele?.plateNumber}</p>
                        <p className="m-0 fm-tawuniyaprice-sum">
                          {getSingleVehiclePrice(ele.chassisNumber).totalPrice}{" "}
                          {t("policyDetails.SAR")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-md-12 mt-3 mb-2">
                <Message severity="info" text={t("MotorEn.Policy-Selected-2")} />
              </div>
            </div>
          </div>
        </p>
      </Dialog>
    </StyleWrapper>
  );
};

export default PolicyDetails;